import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useSelector } from '@grandvisionhq/state';
import { DeliveryIndicatorModalContainer } from './DeliveryIndicatorModal.js';
import { getPreferredShippingMethod } from '../../../state/selectors.js';
import { useGetEstimatedDeliveryMessage } from '../../../hooks/use-get-estimated-delivery-message.js';
import { DeliveryIndicator } from '../components/DeliveryIndicator.js';

var DeliveryIndicatorFullDateContainer = (_param)=>{
    var { items =[] , fallbackLabel , view ='full'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "items",
        "fallbackLabel",
        "view"
    ]);
    const preferredShippingMethod = useSelector(getPreferredShippingMethod);
    const { deliveryMessage , loading , error  } = useGetEstimatedDeliveryMessage(items, preferredShippingMethod);
    return /*#__PURE__*/ React__default.createElement(DeliveryIndicator, swcHelpers.extends({
        deliveryMessage: deliveryMessage,
        loading: loading,
        error: !!error,
        view: view,
        fallbackLabel: fallbackLabel,
        tooltipSlot: /*#__PURE__*/ React__default.createElement(DeliveryIndicatorModalContainer, null)
    }, rest));
};

export { DeliveryIndicatorFullDateContainer };
//# sourceMappingURL=DeliveryIndicatorFullDate.js.map
